module.exports = __webpack_public_path__ + "9f7b6f0efa7a08335fc1547204e8456f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zhiliang_c.png
// module id = 266
// module chunks = 3